import React, { useState, useEffect } from 'react';
import { CheckCircle, AlertCircle, X, Info, AlertTriangle } from 'lucide-react';

const Toast = ({ message, type = 'success', duration = 3000, onClose }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // 입장 애니메이션
    setTimeout(() => setIsAnimating(true), 10);

    // 자동 닫기
    const timer = setTimeout(() => {
      handleClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration]);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      setIsVisible(false);
      onClose();
    }, 300); // duration과 맞추기
  };

  if (!isVisible) return null;

  const getToastConfig = () => {
    switch (type) {
      case 'success':
        return {
          icon: CheckCircle,
          bgClass: 'bg-green-500',
          textClass: 'text-white'
        };
      case 'error':
        return {
          icon: AlertCircle,
          bgClass: 'bg-red-500',
          textClass: 'text-white'
        };
      case 'warning':
        return {
          icon: AlertTriangle,
          bgClass: 'bg-yellow-500',
          textClass: 'text-white'
        };
      case 'info':
        return {
          icon: Info,
          bgClass: 'bg-blue-500',
          textClass: 'text-white'
        };
      default:
        return {
          icon: Info,
          bgClass: 'bg-gray-500',
          textClass: 'text-white'
        };
    }
  };

  const { icon: Icon, bgClass, textClass } = getToastConfig();

  return (
    <div
      className={`toast ${bgClass} ${textClass} ${
        isAnimating ? 'transform translate-y-0 scale-100 opacity-100' : 'transform translate-y-2 scale-95 opacity-0'
      }`}
    >
      <Icon className="w-5 h-5 flex-shrink-0" />
      <span className="text-sm font-medium flex-1">{message}</span>
      <button
        onClick={handleClose}
        className="flex-shrink-0 p-1 rounded hover:bg-black hover:bg-opacity-10 transition-colors"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Toast;